// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pmsgN","location":"Header_location__25xzT"};